<script>
export default {
    name: 'LanguageSwitch',
    data: () => {
        return {
            langs: [ 'de', 'en' ]
        }
    },
    methods: {
        onLangSwitch(lang) {
            this.$i18n.locale = lang;
        },
        isCurrentLang(lang) {
            return this.$i18n.locale === lang;
        }
    },
};
</script>

<template>
    <ul class="lang-switch">
        <li 
            class="lang-switch__lang" 
            v-for="lang in langs"
            v-bind:key="lang"
            v-on:click="onLangSwitch(lang)" 
            v-bind:class="{'lang-switch__lang--hi': isCurrentLang(lang)}">
                <span class="lang-switch__lang__label">{{ lang }}</span>
        </li>
    </ul>
</template>

<style lang="scss" scoped>
@import '../styles/variables';
.lang-switch {
    color: $color-light;
    margin: 0;
    padding: 0;
}
.lang-switch__lang {
    display: inline;
    text-transform: uppercase;
}
.lang-switch__lang:not(:last-child)::after {
    content: " / "
}
.lang-switch__lang__label {
    cursor: pointer;
}
.lang-switch__lang--hi .lang-switch__lang__label {
    padding-bottom: .5rem;
    border-bottom: .0625rem solid $color-light;
}
</style>
